var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.17,
    height: 8.17,
    viewBox: "0 0 8.17 8.17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08268 1.73852L8.26018 0.916016L4.99935 4.17685L1.73852 0.916016L0.916016 1.73852L4.17685 4.99935L0.916016 8.26018L1.73852 9.08268L4.99935 5.82185L8.26018 9.08268L9.08268 8.26018L5.82185 4.99935L9.08268 1.73852Z",
    fill: "#CB282E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross-red.8fc3d283a05b40b997005ad2ad2137c4.svg";
export { ForwardRef as ReactComponent };